import { PLATFORM_THEME_COLORS, Table, Tag, Typography } from '@thinknet-gmbh/platform-common-ui';
import { PaginationProps, TableProps } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { dateFormat } from 'src/common/helpers/date.helpers';
import { useGetCurrentAccount } from 'src/hooks/accounts/get-current-account.hook';
import { IUserData } from 'src/pages/settings/components/user-management/user-management.interfaces';

import UserTablePopover from './components/user-table-popover/user-table-popover.component';

interface IProps extends TableProps<any> {
  dataSource: IUserData[];
  pagination: PaginationProps;
  handleModals: (record: IUserData, modal: string) => void;
}

const UserManagementTable: FC<IProps> = ({ dataSource, handleModals, pagination, onChange }) => {
  const { t } = useTranslation(['common', 'settings']);

  const { account } = useGetCurrentAccount();

  return (
    <Table
      t={t}
      dataSource={dataSource}
      rowKey={(record: IUserData) => record._id}
      pagination={pagination}
      onChange={onChange}
    >
      <Table.Column
        title={t('common:labels.fullName')}
        render={(record: any) => <Typography>{`${record.profile.displayName}`}</Typography>}
      />
      <Table.Column
        title={t('common:labels.email')}
        key="email"
        dataIndex={['account', 'email']}
        render={email => <Typography>{email}</Typography>}
      />
      <Table.Column
        title={t('settings:userManagementSettings.labels.position')}
        key="position"
        dataIndex={['companyPosition', 'name']}
        render={position => <Typography>{position || '-'}</Typography>}
      />
      <Table.Column
        title={t('common:labels.permissionGroups')}
        key="permissionGroup"
        dataIndex={['account', 'permissionGroup']}
        render={permissionGroup => (
          <Tag
            background={PLATFORM_THEME_COLORS.tone.lightYellow}
            fontColor={PLATFORM_THEME_COLORS.tone.yellow}
          >
            {permissionGroup}
          </Tag>
        )}
      />
      <Table.Column
        title={t('common:labels.creationDate')}
        width={150}
        dataIndex="createdAt"
        key="createdAt"
        render={createdAt => <Typography>{dateFormat(createdAt)}</Typography>}
      />
      <Table.Column
        title={t('common:labels.action')}
        width={50}
        render={(record: IUserData) => (
          <UserTablePopover currentAccount={account} record={record} handleModals={handleModals} />
        )}
      />
    </Table>
  );
};

export default UserManagementTable;
